
import { Vue, prop } from "vue-class-component";

class Props {
  fill = prop<boolean>({
    default: false,
    type: Boolean
  });
}
export default class Eye extends Vue.with(Props) {}
